export const VI_ICON = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Contact%20sales%20page/ong/4_checkmark.png";
export const SOCIAL_PROOF_TYPE = "Social Proof";
